export default function () {
  return defineNuxtRouteMiddleware((to) => {
    const { $i18n } = useNuxtApp()
    const { externalUrlData, ...queryRest } = to.query
    const localePath = useLocalePath()

    if (!externalUrlData) {
      return
    }

    const externalUrlDataParsed = JSON.parse(atob(externalUrlData as string))

    const { locale, name, params, query } = externalUrlDataParsed

    if (locale) {
      $i18n.setLocale(locale)
    }

    return navigateTo(
      localePath(
        {
          name,
          params,
          query: {
            ...query,
            ...queryRest,
          },
        },
        locale,
      ),
    )
  })
}
